var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.618,28.515h-0.125v-2.41c0-1.104-0.896-2-2-2s-2,0.896-2,2v2.41h-1.645v-2.41c0-1.104-0.896-2-2-2s-2,0.896-2,2v2.41 h-0.125c-1.104,0-2,0.896-2,2v2.401c0,2.949,2.14,5.402,4.947,5.902v24.131c0,0.604-0.491,1.095-1.095,1.095 s-1.094-0.491-1.094-1.095V47.997c0-3.825-2.639-7.036-6.189-7.932V25.227c0-1.104-0.896-2-2-2H31.098c-1.104,0-2,0.896-2,2v45.494 c0,1.104,0.896,2,2,2h24.195c1.104,0,2-0.896,2-2V44.339c1.298,0.713,2.189,2.076,2.189,3.658v14.952 c0,0.138,0.014,0.273,0.041,0.404c0.21,2.618,2.383,4.691,5.053,4.691c2.671,0,4.844-2.073,5.054-4.691 c0.027-0.13,0.041-0.265,0.041-0.404V38.818c2.807-0.5,4.947-2.953,4.947-5.902v-2.401C74.618,29.411,73.723,28.515,72.618,28.515z  M53.293,27.227v7.689H33.098v-7.689H53.293z M53.293,68.721H33.098V38.916h20.195V68.721z M70.618,32.916c0,1.103-0.897,2-2,2 h-1.895c-1.103,0-2-0.897-2-2v-0.401h5.895V32.916z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasStation);
export default __webpack_public_path__ + "static/media/gas-station.7d0f07b88c097b0b6c2502ddbd8ff5f7.svg";
export { ForwardRef as ReactComponent };